// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"sale-promo-banner_saveTag__QnsMv","text":"sale-promo-banner_text__ibbC7"};